import Managements from "../../components/Managements/Managements";

function ManagementsPage() {
  return <Managements />;
}

export default ManagementsPage;
